<template>
  <Select
    :value="id"
    @on-select="ddddd"
    :clearable="clearable"
    @on-clear="clear"
    @on-change="onChange123"
  >
    <Option v-for="(x, index) in wanggeList" :value="x.id" :key="index">{{
      x.name
    }}</Option>
  </Select>
</template>
<script>
import axios from "axios";
export default {
  props: ["id", "clearable"],
  data() {
    return {
      wanggeList: [],
    };
  },
  methods: {
    ddddd(v) {
      this.$emit("update:id", v.value);
      this.$emit("update:name", v.label);
      this.$emit("on-select", v);
    },
    clear(v) {
      this.$emit("update:id", "");
      this.$emit("update:name", "");
    },
    getWange() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.rule + "/route/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.wanggeList = data;
      });
    },
    onChange123(v) {
      console.log(v);
      this.$emit("on-change", v);
    },
  },
  mounted() {
    this.getWange();
  },
};
</script>




// WEBPACK FOOTER //
// src/components/common/selectLine.vue